<div *ngIf="realTime; else notRealTime" class="notice-block">
  Resources that are real-time replicated to the recovery environment will be restored with current data. Other
  resources will be restored as of {{ snapshotTime }}.
</div>
<ng-template #notRealTime>
  <div class="notice-block">
    Resources will be replicated to the recovery environment with data and infrastructure restored from backups that
    were captured at {{ snapshotTime }}.
  </div>
</ng-template>
